export default [
    {
        path: 'assignment',
        name: 'assignment',
        meta: {
            isDynamic: true,
            id: '任务管理',
            inTab: true
        },
        component: () => import('@/views/assignManage/assignment/index.vue')
    },
    {
        path: 'assignment-update',
        name: 'assignmentUpdate',
        component: () => import('@/views/assignManage/assignment/update')
    },
    {
        path: 'assignment-detail',
        name: 'assignmentDetail',
        component: () => import('@/views/assignManage/assignment/detail')
    },
    {
        path: 'goal',
        name: 'goal',
        meta: {
            isDynamic: true,
            id: '目标管理',
            inTab: true
        },
        component: () => import('@/views/assignManage/goal')
    },
    {
        path: 'goal-update',
        name: 'goalUpdate',
        component: () => import('@/views/assignManage/goal/update')
    },
    {
        path: 'goal-detail',
        name: 'goalDetail',
        component: () => import('@/views/assignManage/goal/detail')
    }
]
